import { c as _c } from "react/compiler-runtime";
import { TaxUnitSelector } from "../../../TaxUnitSelector/TaxUnitSelector";
import { TaxUnitCreateModal } from "../../../TaxUnitModal/TaxUnitCreateModal";
import AnimateHeight from "react-animate-height";
import { Toggle } from "../../../../../shared/components/Widget/components/shared/Toggle/Toggle";
import { DatePickerInput, DatePickerInputConfiguration } from "../../../../../shared/components/DatePicker/DatePickerInput";
import { Distribution, TaxUnit } from "../../../../../../models";
import { DistributionController } from "../../../DistributionCauseAreaInput/Distribution";
import { useState } from "react";
import style from "./AgreementMultipleCauseAreaDetails.module.scss";
import { CauseArea } from "../../../../../shared/components/Widget/types/CauseArea";
import { getStandardOrganizationId, isAllocationVisible, orderDistributionCauseAreas, setCauseAreaStandardSplit, setStandardCauseAreaAmount } from "../../../distributionAmounts";
export type AgreementMultipleCauseAreaDetailsConfiguration = {
  smart_distribution_label: string;
};
export const AgreementMultipleCauseAreaDetails: React.FC<{
  systemCauseAreas: CauseArea[];
  distribution: Distribution;
  savedDistribution: Distribution;
  setDistribution: (dist: Distribution) => void;
  day: number;
  setDay: (day: number) => void;
  taxUnits: TaxUnit[];
  configuration: AgreementMultipleCauseAreaDetailsConfiguration;
  dateSelectorConfig: DatePickerInputConfiguration;
  dateDisabled?: boolean;
}> = t0 => {
  const $ = _c(65);
  const {
    systemCauseAreas,
    distribution,
    savedDistribution,
    setDistribution,
    day,
    setDay,
    taxUnits,
    configuration,
    dateSelectorConfig,
    dateDisabled
  } = t0;
  const [addTaxUnitOpen, setAddTaxUnitOpen] = useState(false);
  let t1;
  if ($[0] !== distribution.taxUnitId || $[1] !== taxUnits) {
    let t2;
    if ($[3] !== distribution.taxUnitId) {
      t2 = unit => unit.id === distribution.taxUnitId;
      $[3] = distribution.taxUnitId;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = taxUnits.find(t2);
    $[0] = distribution.taxUnitId;
    $[1] = taxUnits;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentTaxUnit = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[5] !== configuration || $[6] !== currentTaxUnit || $[7] !== dateDisabled || $[8] !== dateSelectorConfig || $[9] !== day || $[10] !== distribution || $[11] !== savedDistribution || $[12] !== setDay || $[13] !== setDistribution || $[14] !== systemCauseAreas) {
    const distributionAmount = distribution.causeAreas.reduce(_temp, 0);
    let t6;
    if ($[19] !== savedDistribution || $[20] !== systemCauseAreas) {
      t6 = causeArea_0 => {
        const systemCauseArea = systemCauseAreas.find(current => current.id === causeArea_0.id);
        const savedAmount = savedDistribution.causeAreas.find(saved => saved.id === causeArea_0.id)?.amount ?? 0;
        return isAllocationVisible(systemCauseArea ? systemCauseArea.isActive : false, savedAmount, systemCauseArea?.standardPercentageShare);
      };
      $[19] = savedDistribution;
      $[20] = systemCauseAreas;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    const visibleCauseAreas = orderDistributionCauseAreas(distribution.causeAreas, systemCauseAreas).filter(t6);
    t4 = style.wrapper;
    let t7;
    if ($[22] !== setDay) {
      t7 = date => setDay(date);
      $[22] = setDay;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    let t8;
    if ($[24] !== dateDisabled || $[25] !== dateSelectorConfig || $[26] !== day || $[27] !== t7) {
      t8 = <div className={style.valuesDatePickerContainer}><DatePickerInput selected={day} onChange={t7} configuration={dateSelectorConfig} disabled={dateDisabled} /></div>;
      $[24] = dateDisabled;
      $[25] = dateSelectorConfig;
      $[26] = day;
      $[27] = t7;
      $[28] = t8;
    } else {
      t8 = $[28];
    }
    const t9 = formatSum(distributionAmount.toString());
    let t10;
    if ($[29] !== t9) {
      t10 = <output className={style.calculatedAmount} data-cy="agreement-list-amount-input">{t9}</output>;
      $[29] = t9;
      $[30] = t10;
    } else {
      t10 = $[30];
    }
    let t11;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <span>kr</span>;
      $[31] = t11;
    } else {
      t11 = $[31];
    }
    let t12;
    if ($[32] !== t10) {
      t12 = <div className={style.valuesAmountContainer}>{t10}{t11}</div>;
      $[32] = t10;
      $[33] = t12;
    } else {
      t12 = $[33];
    }
    const t13 = currentTaxUnit?.archived === null ? currentTaxUnit : null;
    let t14;
    if ($[34] !== distribution || $[35] !== setDistribution) {
      t14 = unit_0 => setDistribution({
        ...distribution,
        taxUnitId: unit_0.id
      });
      $[34] = distribution;
      $[35] = setDistribution;
      $[36] = t14;
    } else {
      t14 = $[36];
    }
    let t15;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = () => setAddTaxUnitOpen(true);
      $[37] = t15;
    } else {
      t15 = $[37];
    }
    let t16;
    if ($[38] !== t13 || $[39] !== t14) {
      t16 = <div className={style.valuesTaxUnitSelectorContainer}><TaxUnitSelector selected={t13} onChange={t14} onAddNew={t15} /></div>;
      $[38] = t13;
      $[39] = t14;
      $[40] = t16;
    } else {
      t16 = $[40];
    }
    if ($[41] !== t12 || $[42] !== t16 || $[43] !== t8) {
      t5 = <div className={style.values}>{t8}{t12}{t16}</div>;
      $[41] = t12;
      $[42] = t16;
      $[43] = t8;
      $[44] = t5;
    } else {
      t5 = $[44];
    }
    t2 = style.causeAreas;
    let t17;
    if ($[45] !== configuration || $[46] !== distribution || $[47] !== savedDistribution || $[48] !== setDistribution || $[49] !== systemCauseAreas) {
      t17 = (causeArea_1, index) => {
        const systemCauseArea_0 = systemCauseAreas.find(current_0 => current_0.id === causeArea_1.id);
        const causeAreaHasMultipleOrganizations = (systemCauseArea_0?.organizations.length || 0) > 1;
        const standardOrganizationId = systemCauseArea_0 ? getStandardOrganizationId(systemCauseArea_0) : undefined;
        return <div key={`dist-${causeArea_1.id}`}><div className={style.distributionCauseAreaInputHeader}><span>{causeArea_1.name}</span><div className={style.valuesSmartDistributionToggle}>{causeAreaHasMultipleOrganizations && <><span className="caption">{configuration.smart_distribution_label}</span><Toggle active={causeArea_1.standardSplit} onChange={active => setDistribution({
                  ...distribution,
                  causeAreas: distribution.causeAreas.map(current_1 => current_1.id === causeArea_1.id ? setCauseAreaStandardSplit(current_1, active) : {
                    ...current_1
                  })
                })} /></>}</div></div><div className={style.distributionCauseAreaInputPercentageShare}>{causeArea_1.standardSplit ? <><input type="text" value={causeArea_1.amount ?? 0} onChange={e => {
                const amount = Math.max(0, parseInt(e.target.value, 10) || 0);
                const causeAreas = [...distribution.causeAreas];
                const index_0 = causeAreas.findIndex(current_2 => current_2.id === causeArea_1.id);
                if (index_0 === -1 || standardOrganizationId === undefined) {
                  return;
                }
                causeAreas[index_0] = setStandardCauseAreaAmount(causeAreas[index_0], amount, standardOrganizationId);
                setDistribution({
                  ...distribution,
                  causeAreas
                });
              }} data-cy="cause-area-input" /><span>kr</span></> : <><output className={style.calculatedAmount} data-cy="cause-area-input">{formatSum((causeArea_1.amount ?? 0).toString())}</output><span>kr</span></>}</div><AnimateHeight key={index} height={causeArea_1.standardSplit ? 0 : "auto"} animateOpacity={true}><div className={style.distributionCauseAreaInputContainer}><DistributionController causeArea={causeArea_1} savedCauseArea={savedDistribution.causeAreas.find(saved_0 => saved_0.id === causeArea_1.id)} onChange={causeArea_2 => {
                const causeAreas_0 = [...distribution.causeAreas];
                const index_1 = causeAreas_0.findIndex(c => c.id === causeArea_2.id);
                if (index_1 === -1) {
                  causeAreas_0.push(causeArea_2);
                } else {
                  causeAreas_0[index_1] = causeArea_2;
                }
                setDistribution({
                  ...distribution,
                  causeAreas: causeAreas_0
                });
              }} /></div></AnimateHeight></div>;
      };
      $[45] = configuration;
      $[46] = distribution;
      $[47] = savedDistribution;
      $[48] = setDistribution;
      $[49] = systemCauseAreas;
      $[50] = t17;
    } else {
      t17 = $[50];
    }
    t3 = visibleCauseAreas.map(t17);
    $[5] = configuration;
    $[6] = currentTaxUnit;
    $[7] = dateDisabled;
    $[8] = dateSelectorConfig;
    $[9] = day;
    $[10] = distribution;
    $[11] = savedDistribution;
    $[12] = setDay;
    $[13] = setDistribution;
    $[14] = systemCauseAreas;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t2 = $[15];
    t3 = $[16];
    t4 = $[17];
    t5 = $[18];
  }
  let t6;
  if ($[51] !== t2 || $[52] !== t3) {
    t6 = <div className={t2}>{t3}</div>;
    $[51] = t2;
    $[52] = t3;
    $[53] = t6;
  } else {
    t6 = $[53];
  }
  let t7;
  if ($[54] !== t4 || $[55] !== t5 || $[56] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[54] = t4;
    $[55] = t5;
    $[56] = t6;
    $[57] = t7;
  } else {
    t7 = $[57];
  }
  let t8;
  if ($[58] !== addTaxUnitOpen || $[59] !== distribution || $[60] !== setDistribution) {
    t8 = addTaxUnitOpen && <TaxUnitCreateModal open={addTaxUnitOpen} onFailure={_temp2} onSuccess={unit_1 => {
      setDistribution({
        ...distribution,
        taxUnitId: unit_1.id
      });
      setAddTaxUnitOpen(false);
    }} onClose={() => setAddTaxUnitOpen(false)} />;
    $[58] = addTaxUnitOpen;
    $[59] = distribution;
    $[60] = setDistribution;
    $[61] = t8;
  } else {
    t8 = $[61];
  }
  let t9;
  if ($[62] !== t7 || $[63] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[62] = t7;
    $[63] = t8;
    $[64] = t9;
  } else {
    t9 = $[64];
  }
  return t9;
};

/**
 * Take input sum and add a thin seperator between every 3rd digit.
 */
const formatSum = (sum: string) => {
  const parts = sum.split(".");
  const formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.length === 2 ? formatted + "." + parts[1] : formatted;
};
function _temp(total, causeArea) {
  return total + (causeArea.amount ?? 0);
}
function _temp2() {}